import type { Customer } from '@brighterly/lib-core-types/customer/interfaces'
import type { CustomerStore } from '@stores/me/customer/interfaces'

export const marketingData = {
  getMarketingData: (state: CustomerStore): Customer['marketing_data'] | null => state.customer?.marketing_data || null,
  isMarketingData: (state: CustomerStore): boolean => !!state.customer?.marketing_data,
}
